import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Header from '../elements/Header';
import PopUp from '../elements/PopUp';
import NextStep from '../elements/NextStep';
import { CSSTransition } from 'react-transition-group';

import MapView from '../elements/MapView';
import MapElement from '../elements/MapElement';
import MapEconomy from '../elements/MapEconomy';
import MapPolicy from '../elements/MapPolicy';
import Warning from "../../assets/img/icons/warning.svg";
import Defines from '../../Defines';
import { dispatchUnreadPopup } from "../../helpers/popupHelper";
import {
  getUnreadCount,
  unreadCount,
  getEconomieFeedback,
  ministryHasDisaster,
  getPolicyChoiceFeedback,
  getPolicyChoiceTotalPoints,
} from '../../helpers/feedbackHelpers';
import { getTotalCosts, choicesToMake } from '../../helpers/policyChoiceHelper';
import { getMinistryGlobasSpent } from '../../helpers/calculationsHelper';

import Logo from '../../assets/img/logo.png';

import { __, __n } from 'i18n-for-browser';
import DifficultyAwareComponent from "../DifficultyAwareComponent";

/**
 * Import assets
 */
class Home extends DifficultyAwareComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      tour: false,
      tourPopUpCount: 0,
      lowBudgetWarning: true,
      tourPopups: [
        {
          title: 'Welkom in Globaland',
          nextUpType: 'nextPopUp',
          img: Logo,
          buttonText: __('sim_volgende_button'),
          align: 'center'
        },
        {
          title: 'Om te beginnen',
          description: 'Bedenk een leuke naam voor jullie land en upload je teamfoto. \n\n Let op: alleen de teamleider kan informatie invoeren. De overige teamleden kunnen alleen informatie bekijken. Je kunt per spelronde wisselen van rol.',
          nextUpType: 'nextPopUp',
          buttonText: __('sim_volgende_button'),
        },
        {
          title: 'Land besturen',
          description: 'In deze app kun je je land besturen. Elke spelronde bestaat uit 3 stappen: 1. Hoe staat je land ervoor? 2. Belasting heffen 3. Budget verdelen Op sommige plekken kun je pas verder als alle groepen van de klas klaar zijn of als de begeleider het vervolg heeft geactiveerd.',
          nextUpType: 'close',
          buttonText: __('sim_sluiten'),
        }
      ]
    };
    this.toggleTourPopUp = this.toggleTourPopUp.bind(this);
  }

  componentDidMount() {
    const { gameState, dispatch, project } = this.props;
    const currentRound = (gameState.Rounds ? gameState.Rounds.length - 1 : 1);
    if (currentRound === 1 && gameState.currentStep === 1) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhgvtlandbesturen1_T1' : 'mlgvtlandbesturen1_T1'), dispatch);
    }
    if (currentRound === 2 && gameState.currentStep === 1) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhgvtlandbesturen2_T1' : 'mlgvtlandbesturen2_T1'), dispatch, true);
    }
    if (currentRound === 1 && gameState.currentStep === 3) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhgvtbudgetverdelen_T1' : 'mlgvtbudgetverdelen_T1'), dispatch);
    }
  }

  toggleTourPopUp = (direction) => {
    if (direction === "prev" && this.state.tourPopUpCount > 0) {
      if (this.state.tourPopups[(this.state.tourPopUpCount - 1)]) {
        this.setState({
          tourPopUpCount: (this.state.tourPopUpCount - 1)
        });
      }
    } else {
      if (this.state.tourPopups[(this.state.tourPopUpCount + 1)]) {
        this.setState({
          tourPopUpCount: (this.state.tourPopUpCount + 1)
        });
      } else {
        this.setState({
          tour: false
        });
      }
    }
  };

  renderLaag() {
    const position = Defines.position;

    const {
      tour
    } = this.state;
    let currentPopUp = this.state.tourPopups[this.state.tourPopUpCount];
    const { gameState, feedback, myState, policyChoice } = this.props;
    const { prevRoundSum, currentRound } = gameState;
    if (!prevRoundSum) return null;
    const niveau = this.props.project.difficulty.toLowerCase();
    const budget = gameState.totalGameStateSum.globas;
    const currentRoundGameState = gameState.Rounds[currentRound];

    let currentMin = this.props.currentMin;
    if (this.props.history.location.pathname.toLowerCase().indexOf('beleidskeuzes') > -1) {
      currentMin = 'beleidskeuzes';
    }

    if (this.props.history.location.pathname.toLowerCase().indexOf('economy') > -1) {
      currentMin = 'economy';
    }

    console.log(this);

    return (
      <div className={'home-map step-' + gameState.currentStep}>
        <Header history={this.props.history} historic={false} buttonType={'view'} showBudget={gameState.currentStep === 3} />
        <CSSTransition
          in={tour}
          timeout={200}
          classNames="animation"
          unmountOnExit>
          {state => (
            <PopUp
              title={currentPopUp.title}
              description={currentPopUp.description}
              img={currentPopUp.img}
              align={currentPopUp.align}
              nextUpType={currentPopUp.nextUpType}
              buttonText={currentPopUp.buttonText}
              showPopUp={this.state.tour}
              nthPopup={this.state.tourPopUpCount}
              nPopups={this.state.tourPopups.length}
              closePopUpClick={this.toggleTourPopUp}
              navigation={true} />
          )}
        </CSSTransition>
        <MapView history={this.props.history}>
          {gameState.currentStep !== 3 ?
            <MapEconomy
              title={__("sim_economie")}
              target={(currentMin === 'economy' ? '/' : '/economy')}
              top={position["economy"]['basic']["top"]}
              left={
                (!(gameState.currentStep === 1 && gameState.currentRound > 1 && this.props.project.minPolicyChoices > 0) && gameState.currentStep !== 3 ? (
                  position["economy"]['pro']["left"]
                ) : (
                  position["economy"]['basic']["left"]))
              }
              history={this.props.history}
              roundPoints={currentRoundGameState.earnedPoints}
              economy={gameState.totalEconomy}
              feedbackCount={unreadCount(getEconomieFeedback(feedback.prevRoundFeedbackData), true)}
            /> : ''
          }
          {
            !(gameState.currentStep === 1 && gameState.currentRound > 1) && gameState.currentStep !== 3 ? null : (
              this.props.project.minPolicyChoices > 0 ? (
                <MapPolicy
                  title={__n('sim_beleidskeuze', 0)}
                  step={gameState.currentStep}
                  target={(currentMin === 'beleidskeuzes' ? '/' : '/beleidskeuzes')}
                  top={gameState.currentStep === 3 ? position["economy"]['pro']["top"] : position["policy"]["top"]}
                  left={gameState.currentStep === 3 ? position["economy"]['pro']["left"] : position["policy"]["left"]}
                  history={this.props.history}
                  number={gameState.currentStep === 3 ? getTotalCosts(myState.policyChoices, policyChoice) : getPolicyChoiceTotalPoints(feedback.prevRoundFeedbackData)}
                  suffix={gameState.currentStep === 3 ? __('sim_miljard') : __('sim_punten')}
                  feedbackCount={
                    gameState.currentStep === 3
                      ? choicesToMake(policyChoice, myState.policyChoices, this.props.project.minPolicyChoices)
                      : unreadCount(getPolicyChoiceFeedback(feedback.prevRoundFeedbackData), null, true)
                  }
                />
              ) : null
            )
          }
          {Defines.basic.ministries.map(min => (
            <MapElement
              key={min}
              target={`/ministries/${gameState.currentStep === 3 ? 'budget/' : ''}${min.toLowerCase()}`}
              title={__(min)}
              icon={min}
              value={gameState.gameStateSum[`${min}_value`]}
              stars={false}
              international={Defines.i18nMinistries.includes(min)}
              top={position[min]["basic"]["top"]}
              left={position[min]["basic"]["left"]}
              feedbackCount={
                getUnreadCount(min, this.props.feedback.prevRoundFeedbackData)
              }
              difficulty={niveau}
              globas={getMinistryGlobasSpent(myState.ministerieGlobaVerdeling, min, gameState.currentStep)}
              roundPoints={prevRoundSum[`${min}_points`]}
              budgetSet={false}
              policySet={false}
              disaster={ministryHasDisaster(min, this.props.feedback)}
              history={this.props.history}
            // collaboration={ministerieGlobaVerdeling[min + 'SW']}
            />
          ))}
        </MapView>
        {gameState.currentStep === 3 && gameState.currentRound < 4 && this.state.lowBudgetWarning && budget < 30 && !this.props.gameState.history && this.props.project.bankEnabled !== false ? (
          <PopUp
            img={Warning}
            popUpFooter={true}
            description={__('sim_beperkt_budget_melding')}
            showIfUnread={`${gameState.currentRound}-limitedBudget`}
            closePopUpCross={true}
            closePopUpClick={() => this.setState({ lowBudgetWarning: false })} />
        ) : null}
        <NextStep />
      </div>
    );
  }

  renderHoog() {
    const position = Defines.position;

    const {
      tour,
    } = this.state;
    let currentPopUp = this.state.tourPopups[this.state.tourPopUpCount];
    const { gameState, myState, feedback } = this.props;
    const { prevRoundSum } = gameState;
    if (!prevRoundSum) return null;
    const niveau = this.props.project.difficulty.toLowerCase();
    const { ministerieGlobaVerdeling } = myState;
    const policyChoices = Object.values(myState.policyChoices);
    const budget = gameState.totalGameStateSum.globas;

    let currentMin = this.props.currentMin;
    if (this.props.history.location.pathname.toLowerCase().indexOf('economy') > -1) {
      currentMin = 'economy';
    }

    return (
      <div className={'home-map step-' + gameState.currentStep}>
        <Header
          history={this.props.history}
          historic={false}
          buttonType={'view'}
          showBudget={gameState.currentStep === 3} />
        <CSSTransition
          in={tour}
          timeout={200}
          classNames="animation"
          unmountOnExit>
          {state => (
            <PopUp
              title={currentPopUp.title}
              description={currentPopUp.description}
              img={currentPopUp.img}
              align={currentPopUp.align}
              nextUpType={currentPopUp.nextUpType}
              buttonText={currentPopUp.buttonText}
              showPopUp={this.state.tour}
              nthPopup={this.state.tourPopUpCount}
              nPopups={this.state.tourPopups.length}
              closePopUpClick={this.toggleTourPopUp}
              navigation={true} />
          )}
        </CSSTransition>
        <MapView history={this.props.history}>
          {gameState.currentStep !== 3 ? <MapEconomy
            title={__("sim_economie")}
            target={(currentMin === 'economy' ? '/' : '/economy')}
            top={position["economy"]["pro"]["top"]}
            left={position["economy"]["pro"]["left"]}
            roundPoints={gameState.Rounds[gameState.currentRound].earnedPoints}
            economy={gameState.totalEconomy}
            history={this.props.history}
            feedbackCount={unreadCount(getEconomieFeedback(feedback.prevRoundFeedbackData), true)}
          /> : null}
          {Defines.pro.ministries.map(min => (
            <MapElement
              key={min}
              target={`/ministries/${gameState.currentStep === 3 ? 'budget/' : ''}${min.toLowerCase()}`}
              title={__(min)}
              icon={min}
              value={gameState.gameStateSum[`${min}_value`]}
              stars={Defines.ministeryStars[min]}
              international={Defines.i18nMinistries.includes(min)}
              top={position[min]["pro"]["top"]}
              left={position[min]["pro"]["left"]}
              feedbackCount={
                getUnreadCount(min, this.props.feedback.prevRoundFeedbackData)
              }
              difficulty={niveau}
              globas={getMinistryGlobasSpent(ministerieGlobaVerdeling, min, gameState.currentStep, policyChoices)}
              roundPoints={prevRoundSum[`${min}_points`]}
              budgetSet={ministerieGlobaVerdeling[min] && gameState.currentStep > 1}
              policySet={policyChoices.find(choice => choice.ministry === min && choice.selected) && gameState.currentStep > 1}
              history={this.props.history}
              disaster={ministryHasDisaster(min, this.props.feedback)}
            />
          ))}
        </MapView>
        {gameState.currentStep === 3 && gameState.currentRound < 4 && this.state.lowBudgetWarning && budget < 250 && !this.props.gameState.history ? (
          <PopUp
            img={Warning}
            popUpFooter={true}
            description={__('sim_beperkt_budget_melding')}
            showIfUnread={`${gameState.currentRound}-limitedBudget`}
            closePopUpCross={true}
            closePopUpClick={() => this.setState({ lowBudgetWarning: false })} />
        ) : null}
        <NextStep />
      </div>
    );
  }
}

export default connect(({ gameState, gameStateInput, feedback, project, policyChoice }) => ({ gameState, myState: gameStateInput.myState, feedback, project, policyChoice }))(Home);



// WEBPACK FOOTER //
// ./src/components/routes/Home.js